"use strict";
var email_view_model_1 = require("./email-view.model");
var address_view_model_1 = require("./address-view.model");
var base_1 = require("@bhtp-client-api/base");
var edit_1 = require("@bhtp-client-api/edit");
var mapper_helper_1 = require("./../mapper.helper");
var TravelerDetailViewModel = (function () {
    function TravelerDetailViewModel(isPrimary) {
        this.firstName = null;
        this.lastName = null;
        this.birthDate = null;
        this.phoneNumber = null;
        this.tripCost = null;
        this.relationshipToPolicyholder = null;
        this.gender = null;
        this.emailGroup = new email_view_model_1.EmailViewModel();
        this.address = new address_view_model_1.AddressViewModel();
        this.isPrimary = isPrimary;
    }
    /**
     * Return a random correlationId that looks like a Guid
     */
    TravelerDetailViewModel.generateCorrelationId = function () {
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
    };
    TravelerDetailViewModel.toApiTravelers = function (sources) {
        var targets = new Array();
        if (sources) {
            for (var i = 0; i <= sources.length - 1; i++) {
                targets.push(TravelerDetailViewModel.toApiTraveler(sources[i]));
            }
        }
        return targets;
    };
    TravelerDetailViewModel.toApiTraveler = function (traveler) {
        var apiTraveler = new base_1.ApiTraveler();
        apiTraveler.firstName = traveler.firstName;
        apiTraveler.lastName = traveler.lastName;
        apiTraveler.birthDate = traveler.birthDate;
        apiTraveler.email = traveler.emailGroup ? traveler.emailGroup.email : null;
        apiTraveler.phoneNumber = traveler.phoneNumber;
        apiTraveler.isPrimary = traveler.isPrimary;
        apiTraveler.tripCost = traveler.tripCost;
        apiTraveler.relationship = mapper_helper_1.Mapper.emptyToNull(traveler.relationshipToPolicyholder);
        apiTraveler.gender = mapper_helper_1.Mapper.emptyToNull(traveler.gender);
        apiTraveler.address = address_view_model_1.AddressViewModel.toApiAddress(traveler.address);
        return apiTraveler;
    };
    TravelerDetailViewModel.fromApiTraveler = function (source) {
        var target = new TravelerDetailViewModel(source.isPrimary);
        target.birthDate = source.birthDate;
        target.emailGroup = new email_view_model_1.EmailViewModel();
        target.emailGroup.email = source.email;
        target.emailGroup.noEmail = !source.email;
        target.firstName = source.firstName;
        target.lastName = source.lastName;
        target.phoneNumber = source.phoneNumber;
        target.tripCost = source.tripCost;
        target.address = source.address;
        target.gender = (source.gender) ? source.gender.toLowerCase() : null;
        target.relationshipToPolicyholder = source.relationship;
        return target;
    };
    TravelerDetailViewModel.fromApiEditTraveler = function (source) {
        var target = new TravelerDetailViewModel(false);
        if (source) {
            target.birthDate = source.birthDate;
            target.emailGroup.email = source.email;
            target.emailGroup.noEmail = (!source.email);
            target.firstName = source.firstName;
            target.gender = (source.gender ? source.gender.toLocaleLowerCase() : '');
            target.lastName = source.lastName;
            target.phoneNumber = source.phoneNumber;
            target.relationshipToPolicyholder = source.relationship;
            target.address = address_view_model_1.AddressViewModel.fromApiAddress(source.address);
            target.tripCost = source.tripCost;
            target.isPrimary = source.isPrimary;
        }
        return target;
    };
    TravelerDetailViewModel.toApiEditTravelers = function (sources) {
        var targets = new Array();
        if (sources) {
            for (var i = 0; i <= sources.length - 1; i++) {
                targets.push(this.toApiEditTraveler(sources[i]));
            }
        }
        return targets;
    };
    TravelerDetailViewModel.toApiEditTraveler = function (traveler) {
        var apiEditTraveler = new edit_1.ApiEditTraveler();
        apiEditTraveler.firstName = traveler.firstName;
        apiEditTraveler.lastName = traveler.lastName;
        apiEditTraveler.birthDate = traveler.birthDate;
        apiEditTraveler.email = traveler.emailGroup ? traveler.emailGroup.email : null;
        apiEditTraveler.phoneNumber = traveler.phoneNumber;
        apiEditTraveler.isPrimary = traveler.isPrimary;
        apiEditTraveler.tripCost = traveler.tripCost;
        apiEditTraveler.relationship = mapper_helper_1.Mapper.emptyToNull(traveler.relationshipToPolicyholder);
        apiEditTraveler.gender = mapper_helper_1.Mapper.emptyToNull(traveler.gender);
        apiEditTraveler.address = address_view_model_1.AddressViewModel.toApiAddress(traveler.address);
        return apiEditTraveler;
    };
    return TravelerDetailViewModel;
}());
exports.TravelerDetailViewModel = TravelerDetailViewModel;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-models/traveler-detail-view.model.js